import React from 'react';
import language from '../../utils/LanguageSettings';
import translations from '../../text/get-started-translations.json';
import { Link } from 'react-router-dom';
import RenderSnA from '../functions/renderSnA';

const Error404: React.FC = () => {
  const pageTranslations = translations[language];
  const seo : any = {
    "Title" : "Page Not Found"
  }
  const ga : any = {};

  return (
    <>
    <RenderSnA seo={seo} ga={ga} />
    <div className="container-fluid spacer text-center" id="error">
        {language == "en" ? 
        <>
        <h2>
            <span>Oops…</span>
        </h2>
        <h4>{pageTranslations.NotFoundMessage}</h4>
        <p>&nbsp;</p>
        </>
        : 
        <>
        <h4><span style={{"fontSize": "16px"}}>{pageTranslations.NotFoundMessage}</span></h4>
        </>
        }
        <Link to="https://www.nowtv.now.com" className="default-btn my-5">{pageTranslations.GoBackToHome}</Link>
        <div className="topic-row justify-content-center">
            <div className="col-lg-2-5 col-md-4">
                <Link className="boxed-link px-2 d-flex lg_font_size color-5 py-3" to="https://www.nowtv.now.com/">{pageTranslations.Home}</Link>
            </div>
            <div className="col-lg-2-5 col-md-4">
                <Link className="boxed-link px-2 d-flex lg_font_size color-5 py-3" to="https://www.nowtv.now.com/get-started/">{pageTranslations.GetStarted}</Link>
            </div>
            <div className="col-lg-2-5 col-md-4">
                <Link className="boxed-link px-2 d-flex lg_font_size color-5 py-3" to="https://www.nowtv.now.com/support/">{pageTranslations.Support}</Link>
            </div>
            <div className="col-lg-2-5 col-md-4">
                <Link className="boxed-link px-2 d-flex lg_font_size color-5 py-3" to="https://nowplayer.now.com/">{pageTranslations.Watch}</Link>
            </div>
            <div className="col-lg-2-5 col-md-4">
                <Link className="boxed-link px-2 d-flex lg_font_size color-5 py-3" to="https://nowplayer.now.com/tvguide">{pageTranslations.TVGuide}</Link>
            </div>
        </div>
    </div>
    </>
  );
};

export default Error404;